module.exports = __webpack_public_path__ + "media/images/desktop/dropzone-333cf55afe2fff794143126129ccd1eb.png";